module.exports = __webpack_public_path__ + "img/guanjun.b2eb1474.png";